(ns ^:dev/always bp-clients.tv-app.api.graphql.menu
  (:require
   [bp-clients.tv-app.api.graphql.utils :refer [query-builder]]
   [graphql-builder.core :as graphql-builder])
  (:require-macros [graphql-builder.parser :refer [defgraphql]]))

(defgraphql graphql-raw-queries
  "graphql/menu/main.graphql")

(def ^:private query-map (graphql-builder/query-map graphql-raw-queries))
(def ^:private main-menu-raw (get-in query-map [:query :tv-app-menu]))

(defn main-menu-query
  "Gets main menu items from hermes."
  []
  (query-builder main-menu-raw))

(comment
  ;; see the corresponding .graphql files for more impormation
  (main-menu-query))
